export default "__VITE_ASSET__a3263f9e__"